import numeral from 'numeral'
import dayjs from 'dayjs'

/**
 * JS slice
 */
export function slice(data, begin = 0, end = 0, pured = false) {
  if (data && !pured) {
    return (data.length <= end - begin ? data : `${data.slice(begin, end)}...`).replace(/\\r\\n|<br>/g, '')
  } else if (data && pured) {
    return data.slice(begin, end)
  } else {
    return ''
  }
}

// 千分位
export function thousandth(value, alias = true, formatStr = '0,0') {
  if (alias && Number(value) > 1000000) {
    return `${numeral(Math.floor(value / 10000)).format(formatStr)}W`
  }

  return numeral(value).format(formatStr)
}

export function transDate(date) {
  return date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : ''
}

// 切割富文本内容
export function richSplit(content) {
  return content ? content.trim().split(/[(\r\n)\r\n]+/) : []
}
